import modalMixin from './../mixins/_modal';
import flashMessageMixin from './../mixins/_flash_messages';
import itemSearch from './../mixins/_item_search';
import categoryFilter from './_category_filter';
import { eventBus } from '@/helpers/_event_bus';

/**
 *  モーダル版商品検索コンポーネント
 */
export default {
    template: '#modal_item_search_component_template',
    data() {
        // 初期値はgetInitialData()で取得
        return this.getInitialData();
    },
    mixins: [
        modalMixin,
        flashMessageMixin,
        itemSearch,
    ],
    components: {
        // カテゴリ選択コンポーネント
        'category-filter': categoryFilter,
    },
    created: function () {
        // イベントバスでモーダル発火の指示を受け取る
        eventBus.$on('open_modal_item_search', (data) => {
            this.eventBusOn(data);
        });
    },
    computed: {
        // モードは複数選択か
        isModeMultiple: function () {
            return this.mode === 'multiple';
        },
        // 商品追加位置は前方か
        isAddPositionTop: function () {
            return this.add_position === 'top';
        },
        // 選択結果返送先コンポーネントの定義
        resultFor: function () {
            return 'result_for_' + this.from;
        }
    },
    emits: ['selected-page'],
    methods: {
        // dataの初期値
        getInitialData: function () {
            return {
                // 選択済み商品リスト
                selected_item_list: [],
                // カテゴリがDBに一つでも登録があるか
                has_categories: false,
                // カテゴリー一覧
                categories: [],
                // ページキー(カテゴリキー)
                page_key: null,
                //------- EventBusで渡される値 -------
                // 呼び出し元コンポーネント
                from: '',
                // 商品選択モード(normal/multipleのいずれかが入る)
                mode: 'normal',
                // 商品追加位置(前方 or 後方)、複数選択の場合のみ使用する
                add_position: 'top',
                // 選択済み商品リスト（親コンポーネント上）
                parent_selected_item_list: [],
            };
        },
        // サーバからViewに渡されたカテゴリ一覧をセット
        setCategories: function () {
            this.has_categories = false;
            this.categories = [];
            const data = document.querySelector('[data-roll="storecreator_data"]');
            if (!data) {
                return;
            }
            const storecreatorData = JSON.parse(data.innerHTML);

            if (typeof storecreatorData['categories'] !== 'undefined') {
                this.categories = storecreatorData['categories'];
                this.has_categories = true;
            }
        },
        // eventBus有効化
        eventBusOn: function (data) {
            // dataを初期化しておく
            Object.assign(this.$data, this.getInitialData());
            // data定義
            //   from: どのコンポーネントから呼び出されたか
            // (以下はparts_itemから呼び出された時のみ使用)
            //   mode: 選択モード(単一/複数)
            //   add_position: 商品追加先の位置
            //   selected_item: 現在選択中の商品
            this.from = data.from;
            // モードを初期化
            this.mode = 'normal';
            // 複数選択モードでの呼び出し
            if (data.mode === 'multiple') {
                this.mode = data.mode;
                this.add_position = data.add_position;
                this.parent_selected_item_list = data.selected_item;
            }
            this.show();
        },
        // 画面を開く
        show: async function () {
            this.setCategories();
            this.selected_item_list = _.cloneDeep(this.parent_selected_item_list);

            // 検索結果を保持していないなら初回検索
            if (!this.item_list.length) {
                await this.firstSearch();
            // 保持しているならselectedフラグをリセット
            } else {
                this.setSearchedItemList(this.item_list);
            }
            this.open();
        },
        // 商品クリック時処理
        onClickItem: function (index, item) {
            if (this.isModeMultiple) {
                // 複数選択モード時
                this.toggleSelectedOrNot(index, item);
            } else {
                // 通常モード時
                this.selectItem(item);
            }
        },
        // 商品選択/非選択を切り替える
        toggleSelectedOrNot: function (index, item) {
            // 選択/非選択フラグを反転する
            item.selected = !item.selected;
            this.item_list[index] = item;
            // 選択済み商品リスト調整
            const foundIndex = this.findItemByCode(item.item_code);
            if (foundIndex !== -1) {
                // 非選択時、選択商品リストから削除
                if (!item.selected) {
                    this.selected_item_list.splice(foundIndex, 1);
                }
            } else {
                // 選択時、選択商品リストに追加
                if (item.selected) {
                    this.addItem(item);
                }
            }
        },
        // 商品を選択済み商品リストに追加する
        addItem: function (item) {
            if (this.isAddPositionTop) {
                // 前方追加
                this.selected_item_list.unshift(item);
            } else {
                // 後方追加
                this.selected_item_list.push(item);
            }
        },
        /**
         * 商品リストにselectedの項目を追加する
         * @param searchedItemList
         */
        setSearchedItemList: function (searchedItemList) {
            // 検索ボタンクリックにより検索されたとき（ページングでない）選択済み商品リストを初期化
            if (this.$refs.item_search_condition.is_first_search) {
                this.selected_item_list = _.cloneDeep(this.parent_selected_item_list);
            }
            // selectedフラグ追加
            for (const i in searchedItemList) {
                const foundIndex = this.findItemByCode(searchedItemList[i].item_code);
                searchedItemList[i]['selected'] = (foundIndex !== -1) ? true : false;
            }
            this.item_list = searchedItemList;
        },
        /**
         * 商品コードで選択済み商品リストを検索する
         * @param itemCode
         * @returns 見つかればindex、そうでなければ-1
         */
        findItemByCode: function (itemCode) {
            const foundIndex = this.selected_item_list.findIndex(selectedItem => {
                if ('item_code' in selectedItem && selectedItem.item_code === itemCode) {
                    return true;
                }
            });
            return foundIndex;
        },
        /**
         * 商品検索コンポーネントで選択した商品をコピー領域に反映する
         * @param selectedItem
         */
        selectItem: function (selectedItem) {
            this.emitSelectItem(selectedItem);
            this.close();
        },
        // 選択した商品を保存する
        saveSelectedItems: function () {
            this.emitSelectItem(this.selected_item_list);
            this.close();
        },
        // カテゴリー更新時処理
        onUpdatedCategory: async function (pageKey) {
            this.page_key = pageKey;

            this.$nextTick(async function() {
                await this.searchItems(1);
            }, this);
        },

        // -------------------------
        // emit
        // -------------------------

        /**
         * 選択した商品データを通知
         */
        emitSelectItem: function (item) {
            eventBus.$emit(this.resultFor, item, this.mode);
        }
    }
};
